<template>
  <p>
    <component v-if="appConfig" :is="temp" />
  </p>

</template>
<script>
export default {
  components: {
    default1: () => import('~/template/sidebar/default1'),
    dfcp: () => import('~/template/sidebar/dfcp'),
  },
  computed: {
    appConfig() {
      return this.$store.state.service.appConfig;
    },
    temp() {
      if (this.appConfig.hasOwnProperty('index')) {
        return this.appConfig.index
      } else {
        return 'dfcp'
      }
    }
  },
  methods: {}
}
</script>

<style lang="less"></style>
